import { axiosInstance } from "../../../../AppUtils/Utils/axios";
import { filterApiData } from "../../../../AppUtils/Utils/appFunctions";

import {
  getApiProps,
  searchProps,
} from "../../../../AppUtils/Utils/globalTypes";

export const bannerURL = "api/v1/admin/website-setup-app/home-banner-sliders";

//get ablum
export const getBanner = (data: getApiProps) => {
  const { rowsPerPage, page, search } = data;
  return axiosInstance.get(
    `${bannerURL}?offset=${rowsPerPage * page}&limit=${rowsPerPage}&search=${
      search ?? ""
    }${data?.filterData ? filterApiData(data?.filterData) : ""}`
  );
};

//get banner by id
export const getBannerById = (id: number) => {
  return axiosInstance.get(`${bannerURL}/${id}`);
};
//search banner
export const searchBanner = ({ rowsPerPage, search }: searchProps) => {
  return `${bannerURL}?offset=0&limit=${rowsPerPage}&search=${search ?? ""}`;
};
//update banner
export const updateBanner = (body: string | FormData, id: number) =>
  axiosInstance.patch(`${bannerURL}/${id}`, body);
//create banner
export const createBanner = (body: string | FormData) =>
  axiosInstance.post(`${bannerURL}`, body);
